export enum ProgressRoutes {
  ROOT = '',
  DRILL = 'drill'
}
